import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import enAiAssistant from "./locales/en/aiAssistant.json";
// Import translation files (auto-generated registration)
import enAttachments from "./locales/en/attachments.json";
import enAuth from "./locales/en/auth.json";
import enAuthComponents from "./locales/en/authComponents.json";
import enBoardsMenu from "./locales/en/boardsMenu.json";
import enCalendar from "./locales/en/calendar.json";
import enChat from "./locales/en/chat.json";
import enClient from "./locales/en/client.json";
import enClientComponents from "./locales/en/clientComponents.json";
import enClientGallery from "./locales/en/clientGallery.json";
import enClientInfo from "./locales/en/clientInfo.json";
import enClientMoodboard from "./locales/en/clientMoodboard.json";
import enClientPages from "./locales/en/clientPages.json";
import enClients from "./locales/en/clients.json";
import enCommon from "./locales/en/common.json";
import enConfirmationDialog from "./locales/en/confirmationDialog.json";
import enConstants from "./locales/en/constants.json";
import enDataGrid from "./locales/en/dataGrid.json";
import enDateDisplay from "./locales/en/dateDisplay.json";
import enEditableDescription from "./locales/en/editableDescription.json";
import enEntityDetailModal from "./locales/en/entityDetailModal.json";
import enEntityPage from "./locales/en/entityPage.json";
import enEntitySidebar from "./locales/en/entitySidebar.json";
import enErrors from "./locales/en/errors.json";
import enFilterManager from "./locales/en/filterManager.json";
import enForms from "./locales/en/forms.json";
import enHelpCenter from "./locales/en/helpCenter.json";
import enLazyLoadDataGrid from "./locales/en/lazyLoadDataGrid.json";
import enLinkedBoard from "./locales/en/linkedBoard.json";
import enManagementModal from "./locales/en/managementModal.json";
import enMembersList from "./locales/en/membersList.json";
import enMentions from "./locales/en/mentions.json";
import enMetaPublish from "./locales/en/metaPublish.json";
import enMmContributions from "./locales/en/mmContributions.json";
import enMmReadiness from "./locales/en/mmReadiness.json";
import enMultiShop from "./locales/en/multiShop.json";
import enNavigation from "./locales/en/navigation.json";
import enNotificationPopover from "./locales/en/notificationPopover.json";
import enNotifications from "./locales/en/notifications.json";
import enPages from "./locales/en/pages.json";
import enPasswordChecker from "./locales/en/passwordChecker.json";
import enProfile from "./locales/en/profile.json";
import enSearchField from "./locales/en/searchField.json";
import enSelectFilters from "./locales/en/selectFilters.json";
import enServiceEdit from "./locales/en/serviceEdit.json";
import enServiceTree from "./locales/en/serviceTree.json";
import enServiceWizard from "./locales/en/serviceWizard.json";
import enSettings from "./locales/en/settings.json";
import enSettingsComponents from "./locales/en/settingsComponents.json";
import enSettingsPages from "./locales/en/settingsPages.json";
import enShared from "./locales/en/shared.json";
import enShell from "./locales/en/shell.json";
import enSubtaskCreation from "./locales/en/subtaskCreation.json";
import enSubtaskEdit from "./locales/en/subtaskEdit.json";
import enTablesMenu from "./locales/en/tablesMenu.json";
import enTasksTable from "./locales/en/tasksTable.json";
import enTeamBoard from "./locales/en/teamBoard.json";
import enUi from "./locales/en/ui.json";
import itAiAssistant from "./locales/it/aiAssistant.json";
import itAttachments from "./locales/it/attachments.json";
import itAuth from "./locales/it/auth.json";
import itAuthComponents from "./locales/it/authComponents.json";
import itBoardsMenu from "./locales/it/boardsMenu.json";
import itCalendar from "./locales/it/calendar.json";
import itChat from "./locales/it/chat.json";
import itClient from "./locales/it/client.json";
import itClientComponents from "./locales/it/clientComponents.json";
import itClientGallery from "./locales/it/clientGallery.json";
import itClientInfo from "./locales/it/clientInfo.json";
import itClientMoodboard from "./locales/it/clientMoodboard.json";
import itClientPages from "./locales/it/clientPages.json";
import itClients from "./locales/it/clients.json";
import itCommon from "./locales/it/common.json";
import itConfirmationDialog from "./locales/it/confirmationDialog.json";
import itConstants from "./locales/it/constants.json";
import itDataGrid from "./locales/it/dataGrid.json";
import itDateDisplay from "./locales/it/dateDisplay.json";
import itEditableDescription from "./locales/it/editableDescription.json";
import itEntityDetailModal from "./locales/it/entityDetailModal.json";
import itEntityPage from "./locales/it/entityPage.json";
import itEntitySidebar from "./locales/it/entitySidebar.json";
import itErrors from "./locales/it/errors.json";
import itFilterManager from "./locales/it/filterManager.json";
import itForms from "./locales/it/forms.json";
import itHelpCenter from "./locales/it/helpCenter.json";
import itLazyLoadDataGrid from "./locales/it/lazyLoadDataGrid.json";
import itLinkedBoard from "./locales/it/linkedBoard.json";
import itManagementModal from "./locales/it/managementModal.json";
import itMembersList from "./locales/it/membersList.json";
import itMentions from "./locales/it/mentions.json";
import itMetaPublish from "./locales/it/metaPublish.json";
import itMmContributions from "./locales/it/mmContributions.json";
import itMmReadiness from "./locales/it/mmReadiness.json";
import itMultiShop from "./locales/it/multiShop.json";
import itNavigation from "./locales/it/navigation.json";
import itNotificationPopover from "./locales/it/notificationPopover.json";
import itNotifications from "./locales/it/notifications.json";
import itPages from "./locales/it/pages.json";
import itPasswordChecker from "./locales/it/passwordChecker.json";
import itProfile from "./locales/it/profile.json";
import itSearchField from "./locales/it/searchField.json";
import itSelectFilters from "./locales/it/selectFilters.json";
import itServiceEdit from "./locales/it/serviceEdit.json";
import itServiceTree from "./locales/it/serviceTree.json";
import itServiceWizard from "./locales/it/serviceWizard.json";
import itSettings from "./locales/it/settings.json";
import itSettingsComponents from "./locales/it/settingsComponents.json";
import itSettingsPages from "./locales/it/settingsPages.json";
import itShared from "./locales/it/shared.json";
import itShell from "./locales/it/shell.json";
import itSubtaskCreation from "./locales/it/subtaskCreation.json";
import itSubtaskEdit from "./locales/it/subtaskEdit.json";
import itTablesMenu from "./locales/it/tablesMenu.json";
import itTasksTable from "./locales/it/tasksTable.json";
import itTeamBoard from "./locales/it/teamBoard.json";
import itUi from "./locales/it/ui.json";

const resources = {
  en: {
    attachments: enAttachments,
    auth: enAuth,
    authComponents: enAuthComponents,
    calendar: enCalendar,
    chat: enChat,
    client: enClient,
    clientComponents: enClientComponents,
    clientGallery: enClientGallery,
    clientInfo: enClientInfo,
    clientMoodboard: enClientMoodboard,
    clients: enClients,
    common: enCommon,
    confirmationDialog: enConfirmationDialog,
    constants: enConstants,
    dataGrid: enDataGrid,
    dateDisplay: enDateDisplay,
    editableDescription: enEditableDescription,
    entityDetailModal: enEntityDetailModal,
    entityPage: enEntityPage,
    entitySidebar: enEntitySidebar,
    errors: enErrors,
    filterManager: enFilterManager,
    forms: enForms,
    helpCenter: enHelpCenter,
    lazyLoadDataGrid: enLazyLoadDataGrid,
    linkedBoard: enLinkedBoard,
    managementModal: enManagementModal,
    membersList: enMembersList,
    mentions: enMentions,
    metaPublish: enMetaPublish,
    mmContributions: enMmContributions,
    mmReadiness: enMmReadiness,
    multiShop: enMultiShop,
    navigation: enNavigation,
    notificationPopover: enNotificationPopover,
    notifications: enNotifications,
    pages: enPages,
    passwordChecker: enPasswordChecker,
    profile: enProfile,
    searchField: enSearchField,
    selectFilters: enSelectFilters,
    serviceEdit: enServiceEdit,
    serviceTree: enServiceTree,
    serviceWizard: enServiceWizard,
    settings: enSettings,
    settingsComponents: enSettingsComponents,
    settingsPages: enSettingsPages,
    shared: enShared,
    subtaskCreation: enSubtaskCreation,
    subtaskEdit: enSubtaskEdit,
    tasksTable: enTasksTable,
    teamBoard: enTeamBoard,
    aiAssistant: enAiAssistant,
    boardsMenu: enBoardsMenu,
    clientPages: enClientPages,
    shell: enShell,
    tablesMenu: enTablesMenu,
    ui: enUi,
  },
  it: {
    attachments: itAttachments,
    auth: itAuth,
    authComponents: itAuthComponents,
    calendar: itCalendar,
    chat: itChat,
    client: itClient,
    clientComponents: itClientComponents,
    clientGallery: itClientGallery,
    clientInfo: itClientInfo,
    clientMoodboard: itClientMoodboard,
    clients: itClients,
    common: itCommon,
    confirmationDialog: itConfirmationDialog,
    constants: itConstants,
    dataGrid: itDataGrid,
    dateDisplay: itDateDisplay,
    editableDescription: itEditableDescription,
    entityDetailModal: itEntityDetailModal,
    entityPage: itEntityPage,
    entitySidebar: itEntitySidebar,
    errors: itErrors,
    filterManager: itFilterManager,
    forms: itForms,
    helpCenter: itHelpCenter,
    lazyLoadDataGrid: itLazyLoadDataGrid,
    linkedBoard: itLinkedBoard,
    managementModal: itManagementModal,
    membersList: itMembersList,
    mentions: itMentions,
    metaPublish: itMetaPublish,
    mmContributions: itMmContributions,
    mmReadiness: itMmReadiness,
    multiShop: itMultiShop,
    navigation: itNavigation,
    notificationPopover: itNotificationPopover,
    notifications: itNotifications,
    pages: itPages,
    passwordChecker: itPasswordChecker,
    profile: itProfile,
    searchField: itSearchField,
    selectFilters: itSelectFilters,
    serviceEdit: itServiceEdit,
    serviceTree: itServiceTree,
    serviceWizard: itServiceWizard,
    settings: itSettings,
    settingsComponents: itSettingsComponents,
    settingsPages: itSettingsPages,
    shared: itShared,
    subtaskCreation: itSubtaskCreation,
    subtaskEdit: itSubtaskEdit,
    tasksTable: itTasksTable,
    teamBoard: itTeamBoard,
    aiAssistant: itAiAssistant,
    boardsMenu: itBoardsMenu,
    clientPages: itClientPages,
    shell: itShell,
    tablesMenu: itTablesMenu,
    ui: itUi,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "it",
    // Normalize regional variants (e.g. "it-IT" -> "it") so locale-dependent
    // lookups (date-fns, dayjs, exact language comparisons) match correctly.
    supportedLngs: ["it", "en"],
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    defaultNS: "common",
    ns: [
      "attachments",
      "auth",
      "authComponents",
      "calendar",
      "chat",
      "client",
      "clientComponents",
      "clientGallery",
      "clientInfo",
      "clientMoodboard",
      "clients",
      "common",
      "confirmationDialog",
      "constants",
      "dataGrid",
      "dateDisplay",
      "editableDescription",
      "entityDetailModal",
      "entityPage",
      "entitySidebar",
      "errors",
      "filterManager",
      "forms",
      "helpCenter",
      "lazyLoadDataGrid",
      "linkedBoard",
      "managementModal",
      "membersList",
      "mentions",
      "metaPublish",
      "mmContributions",
      "mmReadiness",
      "multiShop",
      "navigation",
      "notificationPopover",
      "notifications",
      "pages",
      "passwordChecker",
      "profile",
      "searchField",
      "selectFilters",
      "serviceEdit",
      "serviceTree",
      "serviceWizard",
      "settings",
      "settingsComponents",
      "settingsPages",
      "shared",
      "subtaskCreation",
      "subtaskEdit",
      "tasksTable",
      "teamBoard",
      "aiAssistant",
      "boardsMenu",
      "clientPages",
      "shell",
      "tablesMenu",
      "ui",
    ],

    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    react: {
      useSuspense: false, // Disable suspense mode for better error handling
    },
  });

export default i18n;
